import axios from 'axios'

export default {
  createPreference(projectId, scenarioId, optionId) {
    const minimalPrefence = {
      scenarioId: scenarioId,
      wigo: [optionId]
    }
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences`, minimalPrefence)
  },
  deletePreference(projectId, preferenceId) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences/${preferenceId}`)
  },
}